import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function PortalItinerary() {
  const [trip, setTrip] = useState(null);
  useEffect(() => { api.get("/portal/trip").then((r) => setTrip(r.data.trip)); }, []);

  if (!trip) return <div className="px-6 md:px-14 py-20"><p className="eyebrow text-ink/50">Loading…</p></div>;

  return (
    <div className="px-6 md:px-14 py-14 md:py-20 max-w-5xl">
      <p className="eyebrow">Day by day</p>
      <h1 className="mt-4 font-serif text-4xl md:text-6xl text-jade font-light leading-[1.05]">{trip.title}</h1>
      <p className="mt-4 text-ink/65 text-[14px] tracking-[0.16em] uppercase">{trip.start_date} → {trip.end_date}</p>

      <ol data-testid="portal-itinerary" className="mt-14 relative">
        <div className="absolute left-[10px] top-2 bottom-2 w-px bg-mist" aria-hidden />
        {(trip.itinerary || []).map((d) => (
          <li key={d.day} data-testid={`portal-day-${d.day}`} className="relative pl-12 pb-12 last:pb-0">
            <span className="absolute left-0 top-1 w-5 h-5 rounded-full border border-jade bg-ivory flex items-center justify-center">
              <span className="w-1.5 h-1.5 rounded-full bg-copper" />
            </span>
            <p className="eyebrow text-jade">Day {d.day}</p>
            <h3 className="mt-2 font-serif text-2xl md:text-3xl text-jade font-light">{d.title}</h3>
            <p className="mt-3 text-ink/75 text-[15px] font-light leading-[1.85] max-w-2xl">{d.summary}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
